import io from 'socket.io-client';
import { SERVER_URL } from './index';

const socket = io(SERVER_URL);
//const socket = io('http://localhost:4001');
//const socket = io('https://api.watchupgrade.com:4004');

export default socket;
